'use es6';

import MerchCardsToShow from '../constants/MerchCardsToShow';
import { availableTermsForSkuSelector } from './OfferSelectors';
import { hasProductLevelOrHigherInProductInventorySelector } from './ProductInventorySelectors';
import { currentSkuIdForProductSelector, productForSkuIdSelector } from './ProductsSelectors';
export const shouldShowTermSelectorForMerchSelector = (state, {
  skuId
}) => {
  const availableTerms = availableTermsForSkuSelector(state, {
    skuId
  });
  const hasTwoTerms = availableTerms.length > 1;
  const {
    productLine,
    productLevel
  } = productForSkuIdSelector(state, {
    skuId
  }) || {};
  const ownsProductOrHigher = hasProductLevelOrHigherInProductInventorySelector(state, {
    productLine,
    productLevel
  });
  return hasTwoTerms && !ownsProductOrHigher;
}; // Used to determine if we should render smaller padding
// between title and ctas in merch cards

export const hasTermSelectorOnPageSelector = (state, {
  productLine
}) => {
  const productLevels = MerchCardsToShow[productLine];
  return productLevels.some(productLevel => {
    const skuId = currentSkuIdForProductSelector(state, {
      productLine,
      productLevel
    });
    return skuId && shouldShowTermSelectorForMerchSelector(state, {
      skuId
    });
  });
};